// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

// components
import ProductBase from 'shared/components/Product';
import Placeholder from 'shared/components/Product/Placeholder';
import CAVProduct from 'shared/layouts/DetailsPage/components/Widgets/components/CAVProduct';

// styles
import { HIDE_SCROLLBARS } from 'shared/styles/base';

// constants
import { STATIC_PRODUCT_CARD_WIDTH } from 'shared/constants';

// helper
import NFA from 'shared/helpers/analytics/NFAnalytics';
import { LOGIN_LOCATIONS, LOGIN_PAGE } from 'shared/helpers/analytics/constants/loginEvents';
import { WISHLIST_INTERACTION } from 'shared/helpers/analytics/constants/wishlist';
import { PRODUCT_INTERACTION } from 'shared/helpers/analytics/constants';

const InnerWidget = styled.div`
  ${HIDE_SCROLLBARS};
  display: flex;
  scroll-snap-type: x mandatory;
  overflow-x: auto;
`;

const PlaceHolderWrapper = styled(Placeholder)`
  min-width: calc(40% + 1rem);
  margin-right: ${({ theme }) => theme.spacing.spacing40};

  &:first-of-type {
    padding-left: ${({ theme }) => theme.spacing.spacing80};
    box-sizing: content-box;
  }
`;

const Product = styled(ProductBase)`
  min-width: 40%;
  width: 40%;
  margin-right: 8px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
  scroll-snap-align: start;

  &:first-of-type {
    min-width: calc(40% + ${({ theme }) => theme.spacing.spacing80});
    padding-left: ${({ theme }) => theme.spacing.spacing80};
  }

  &:last-of-type {
    margin-right: ${({ theme }) => theme.spacing.spacing80};
  }
`;

interface IMobileCarousel {
  products: Listing.IProduct[];
  isCAV?: boolean;
  widgetMetadata: Record<string, any>;
}

function MobileCarousel({ products, isCAV, widgetMetadata }: IMobileCarousel) {
  const onWishlistClick = () => {
    NFA.updateDataLayer({
      loginPage: LOGIN_PAGE.RECO_WIDGET,
      loginLocation: LOGIN_LOCATIONS.WISHLIST_ICON_PRODUCT,
      wishlistInteraction: WISHLIST_INTERACTION.RECO_WIDGET,
    });
  };

  const onProductInteraction = () => {
    NFA.updateDatalayerBeforeNext({
      productInteractedType: PRODUCT_INTERACTION.RECO_WIDGET,
      widgetTitle: widgetMetadata?.widgetTitle,
      widgetType: widgetMetadata?.widgetType,
    });
  };
  return (
    <InnerWidget>
      {products.map((product: Listing.IProduct, index: number) =>
        isCAV ? (
          <CAVProduct key={product.id} item={product} onClick={onProductInteraction} />
        ) : (
          <Product
            className="carousel-product"
            key={product.id}
            item={product}
            width={STATIC_PRODUCT_CARD_WIDTH}
            showWishlist
            trackingMetadata={{ productPosition: index + 1, ...widgetMetadata }}
            fallback={<PlaceHolderWrapper />}
            onWishlistClick={onWishlistClick}
            onInteraction={onProductInteraction}
          />
        )
      )}
    </InnerWidget>
  );
}

export default memo(MobileCarousel);
